export default __webpack_public_path__ + "static/noun_team build_2176769-ca968f428abdb162191024a95fb95098.svg";